import { defineComponent as _defineComponent } from 'vue'
import MachinationsShapeBackground from "~/components/MachinationsShapesBackground.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'TermsHero',
  setup(__props) {


return { __sfc: true,MachinationsShapeBackground }
}

})